import { Component } from '@angular/core';

@Component({
  selector: 'all-product-skeleton-loader',
  templateUrl: './all-product-skeleton-loader.component.html',
  standalone: false,
})
export class AllProductSkeletonLoaderComponent {}
